import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { UpgradesDowngradesPage, UpgradesDowngradesPageProps } from "./UpgradesDowngradesPage";

export const EMPTY_PAGE_CONTENT: UpgradesDowngradesPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/electricity/connection-changes/upgrades-downgrades";

export const UpgradesDowngradesPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<UpgradesDowngradesPageProps>(
    "electricity_changes___capacity_upgrade_and_downgra",
    EMPTY_PAGE_CONTENT,
  );
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <UpgradesDowngradesPage {...routeProps} {...content} />;
};
